// extracted by mini-css-extract-plugin
export default {"container":"PV-z","title":"QV-z","link":"RV-z"};